/**
 * The recessed tray shared by segmented controls and toolbars, so a bar holding
 * both reads as one set of tools. The inset neutral area (`surface-elevated`) with the
 * neutral frame: tokens only, no local opacity variants.
 */
export const INSET_GROUP_CLASS = "bg-surface-elevated ring-1 ring-border";
